import { EditorState, convertFromRaw } from "draft-js";

const helperFunctions = {
  checkImageIsInCorrectFormat(image) {
    let regex = RegExp("^@[a-zA-Z0-9+/]+={0,2}$");
    return regex.test(image);
  },
  checkEditorStateHasValue(raw_data) {
    const create_editor_state = EditorState.createWithContent(
      convertFromRaw(JSON.parse(raw_data))
    );
    return create_editor_state.getCurrentContent().hasText();
  }
};

export default helperFunctions;
